import "./tabs.scss";
import React, { useEffect, useState } from "react";
import StatusSelect from "../modals/c3toc3-filter";
import {
  getBillpayementList,
  getCountryList,
} from "../../../../service/profile-ras-service";
import Billpayementspresentaional from "./billpayementspresentational";
import BillDetailsPopup from "./../modals/biller-billpayements-modal";
import moment from "moment";

const BillPayments = ({ userId }) => {
  const [searchBy, setSearchBy] = useState("nickName");
  const [searchByValue, setSearchByValue] = useState("");
  const [BillerCountry, setBillerCountry] = useState("");
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showPopupModal, setShowPopupModal] = useState(false);
  const [billdetails, setBilldetails] = useState([]);
  const [sizeShow, setSizeShow] = useState();
  const [selectedOption, setSelectedOption] = useState([]);
  const [popupData, setPopupData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const request = {
    page: 1,
    size: 10,
    billerName: "",
    nickName: "",
    billerCountry: "",
    fromDate: null,
    toDate: null,
  };
  const [filterForm, setFilterForm] = useState(request);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });

  const columns = [
    {
      dataField: "date",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.date) || null).format("DD-MM-YY  HH:mm:ss");
      },
    },
    {
      dataField: "nickName",
      text: "Nick Name",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "100px", textAlign: "center" },
    },

    {
      dataField: "billerName",
      text: " Biller Name",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "billAmount",
      text: " Bill Amount",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },

    {
      dataField: "country",
      text: " Biller Country",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "status",
      text: " Status",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "c3Ref",
      text: " C3 REF",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "paykiiRef",
      text: " Paykii REF",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },

    {
      dataField: "actions",
      text: "Actions",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "15px", textAlign: "center" },
      formatter: (cell, row) => {
        let states = { ...row };
        return (
          <div
            style={{ color: "black" }}
            onClick={() => {
              if (row && row.id) {
                let data = [
                  { value: `${row.billerName}`, label: "Biller" },
                  { value: `${row.billAmount}`, label: "Bill Amount" },
                  {
                    value: `${row.convertedBillAmount}`,
                    label: "Bill Amount(AED)",
                  },
                  { value: `${row.feeAmount}`, label: "Fee(AED)" },
                  {
                    value: `${row.providerCharge}`,
                    label: "Mandatory Fee",
                  },
                  {
                    value: `${row.convertedBillAmount + row.feeAmount}`,
                    label: "Debited(AED)",
                  },
                  { value: `${row.billerId}`, label: "Biller Id " },
                ];
                let ref = row.referenceFields;
                let refId = ref.split(",");
                let temp = refId[0] && refId[0].split("|");
                let temp2 = refId[1] && refId[1].split("|");
                temp &&
                  data.push({
                    value: `${temp && temp[1]}`,
                    label: `${temp && temp[0]}`,
                  });
                temp2 &&
                  data.push({
                    value: `${temp2 && temp2[1]}`,
                    label: `${temp2 && temp2[0]}`,
                  });
                data.push(
                  { value: `${row.c3Ref}`, label: "C3 Ref" },
                  {
                    value: `${row.paykiiRef ? row.paykiiRef : "N/A"}`,
                    label: "Paykii Ref",
                  }
                );
                setPopupData(data);
                setShowPopupModal(true);
              }
            }}
          >
            <i style={{ fontSize: 18 }} className="fas fa-search" />
          </div>
        );
      },
    },
  ];
  const [id, setId] = useState();
  const billercountrylist = () => {
    getCountryList("BILLPAYMENT")
      .then((res) => {
        let response = res.data;
        let options =
          response &&
          response.map((list) => {
            return { value: list.code, label: list.name };
          });
        setCountryList(options);
      })

      .catch((err) => {
        setCountryList([]);
      });
  };

  useEffect(() => {
    if (userId) {
      setId(userId);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getTabC3Transaction(filterForm, id);
      billercountrylist();
    }
  }, [id]);

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getTabC3Transaction(filterForm, id);
    }
  }, [filterForm]);

  const getTabC3Transaction = (request, id) => {
    // setBilldetails([]);
    request.size = sizeShow || 10;
    setDataLoading(true);
    getBillpayementList(request, id)
      .then((res) => {
        setDataLoading(false);
        setBilldetails(res.data.transactions || []);
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);

        setBilldetails([]); // TODO -NEED TO REMOVE
      });
  };

  const handleFilter = () => {
    let request = {};
    if (searchBy === "billerName") {
      request = {
        ...filterForm,
        billerName: searchByValue,
      };
    } else if (searchBy === "nickName") {
      request = {
        ...filterForm,
        nickName: searchByValue,
      };
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate = (toDate && moment(toDate).format("YYYY-MM-DD")) || null;
    request.isFilter = true;
    request.billerCountry = BillerCountry;
    request.page = 1;
    setFilterForm(request);
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "nickName") {
    searchByValuePlaceholder = "Damon";
  } else if (searchBy === "billerName") {
    searchByValuePlaceholder = "Stefan";
  }

  const statusFilter = () => {
    setNoOfFiltersSelected(selectedOption.length);
    setShowFilterModal(false);
    setFiltersSelected(true);
    selectedOption.map((option) => {
      switch (option.label) {
        case option.label:
          setBillerCountry(option.value);
        default:
          return "";
      }
    });
  };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedOption([{ ...selectedOption }]);
    }
  };

  const resetFilter = () => {
    setSearchBy("nickName");
    request.isFilter = true;
    setFromDate(null);
    setToDate(null);
    setBillerCountry("");
    setShowPopupModal(false);
    setFiltersSelected(false);
    setSearchByValue("");
    setSelectedOption([]);
    setPopupData([]);
    setBilldetails([]);
    setFilterForm(request);
  };

  return (
    <>
      <Billpayementspresentaional
        {...{
          searchBy,
          setSearchBy,
          setSearchByValue,
          searchByValue,
          searchByValuePlaceholder,
          handleFilter,
          setFromDate,
          fromDate,
          setToDate,
          toDate,
          setShowFilterModal,
          filtersSelected,
          resetFilter,
          noOfFiltersSelected,
          billdetails,
          columns,
          pagination,
          setFilterForm,
          setSizeShow,
          dataLoading,
          filterForm,
        }}
      />
      <StatusSelect
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        handleChange={handleChange}
        options={countryList}
        selectedOption={selectedOption}
        statusFilter={statusFilter}
        placeholder="Biller Country"
      />
      <BillDetailsPopup
        show={showPopupModal}
        close={() => setShowPopupModal(false)}
        popupData={popupData}
        title="Payment details"
      />
    </>
  );
};
export default BillPayments;
